import ApiCoreService from "./api-core";

const apiCoreService = new ApiCoreService();

const CoreAPI = {
    apiCoreService,
}

export default CoreAPI;